export default function FooterSection() {
  return (
    <footer className="bg-gray-900 text-white py-14">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8 mb-10">
          {/* Logo & tagline */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <img
              src="https://static.readdy.ai/image/28a02ba018e540cb808856dcffc9a7b1/1d29588582cc4ce2185161fe660b749c.png"
              alt="Dolar Hoy Venezuela"
              className="h-8 w-auto object-contain"
            />
            <p className="text-gray-400 text-sm max-w-xs text-center md:text-left">
              Tu referencia diaria del precio del dólar en Venezuela.
            </p>
          </div>

          {/* Quick links */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <p className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-1">Secciones</p>
            <a href="#tasa" className="text-gray-400 hover:text-green-400 text-sm transition-colors cursor-pointer">Tasa del dólar</a>
            <a href="#comparar" className="text-gray-400 hover:text-green-400 text-sm transition-colors cursor-pointer">Comparar servicios</a>
          </div>

          {/* Services */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <p className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-1">Servicios</p>
            <a href="https://wise.com" target="_blank" rel="nofollow noopener noreferrer" className="text-gray-400 hover:text-green-400 text-sm transition-colors cursor-pointer">Wise</a>
            <a href="https://remitly.com" target="_blank" rel="nofollow noopener noreferrer" className="text-gray-400 hover:text-green-400 text-sm transition-colors cursor-pointer">Remitly</a>
            <a href="https://westernunion.com" target="_blank" rel="nofollow noopener noreferrer" className="text-gray-400 hover:text-green-400 text-sm transition-colors cursor-pointer">Western Union</a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs text-center sm:text-left">
            © 2026 Dolar Hoy Venezuela. Todos los derechos reservados.
          </p>
          <p className="text-gray-600 text-xs text-center sm:text-right italic max-w-sm">
            Información referencial. Las tasas pueden variar. No somos una entidad financiera.
          </p>
        </div>
      </div>
    </footer>
  );
}
